import * as React from "react";
import PropTypes from "prop-types";
import Button from "nx-components/Button";
import prefixStyles from "nx-components/utils/prefixStyles";
import { IconDigit, IconEmptyDigit } from "nx-components/Icons";
import Environment from "nexia_mobile/environment";
import LockScreenBrandLogo from "nexia_mobile/components/BrandLogo/LockScreenBrandLogo";
import PivotLockScreenBrandLogo from "nexia_mobile/components/BrandLogo/PivotLockScreenBrandLogo";

const styles = prefixStyles({
  digit: {
    flex: "100%",
    textAlign: "center",
    verticalAlign: "middle",
    minHeight: "1em",
    display: "inline-block",
  },
  iconDigit: {
    flexShrink: "0",
  },
  aForgotPin: {
    fontSize: "0.6em",
    margin: "0.75em",
    textTransform: "uppercase",
  },
  digitContainer: {
    display: "flex",
    fontSize: "1.3em",
    marginTop: "0.5em",
  },
});

const ForgotPin = (props) => {
  const { onForgotPin } = props;

  return (
    <Button theme="link" style={styles.aForgotPin} onTap={onForgotPin}>
      Forgot pin?
    </Button>
  );
};

ForgotPin.propTypes = {
  onForgotPin: PropTypes.func,
};

const Digit = (props) => {
  const { entryValue, password, digitValue, small } = props;
  const width = small ? "0.6em" : "0.7em";
  if (entryValue[digitValue]) {
    if (password) {
      return <IconDigit style={{ ...styles.iconDigit, width }} />;
    } else {
      return (
        <span style={{ ...styles.digit, width }}>{entryValue[digitValue]}</span>
      );
    }
  } else {
    return <IconEmptyDigit style={{ ...styles.iconDigit, width }} />;
  }
};

Digit.propTypes = {
  entryValue: PropTypes.string,
  password: PropTypes.bool,
  digitValue: PropTypes.number,
  small: PropTypes.bool,
};

export const Digits = ({ length, value, password }) => {
  let numbers = [];
  for (let i = 0; i < length; i++) {
    numbers.push(i);
  }
  const digits = numbers.map((number) => (
    <Digit
      key={number.toString()}
      digitValue={number}
      entryValue={value}
      password={password}
      small={length > 8}
    />
  ));
  return digits;
};
Digits.propTypes = {
  length: PropTypes.number.isRequired,
  value: PropTypes.string.isRequired,
  password: PropTypes.bool,
};

const Prompt = ({
  isPortrait,
  prompt,
  length,
  password,
  disabled,
  value,
  onForgotPin,
  showForgotPin,
  isTablet,
  children,
}) => {
  const isCommercial = Environment.isCommercial();
  const promptStyles = prefixStyles({
    promptMessage: {
      color: disabled ? "#f75034" : null,
      textAlign: "center",
      marginTop: isCommercial ? "0.5em" : null,
    },
    prompt: {
      flexGrow: "0",
      flexShrink: "1",
      flexBasis: "auto",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      marginBottom: "1em",
      fontSize: isTablet ? "1.5em" : "",
      maxWidth: isPortrait ? null : "50%",
      minWidth: isPortrait ? null : "33%",
      marginTop: isPortrait ? null : "0.5em",
      marginRight: isPortrait ? null : "0.5em",
      marginLeft: isPortrait ? null : "0.5em",
    },
  });

  return (
    <div style={promptStyles.prompt}>
      {isCommercial ? (
        <PivotLockScreenBrandLogo />
      ) : (
        <LockScreenBrandLogo
          width={isTablet ? "12em" : undefined}
          height={isTablet ? "6em" : undefined}
        />
      )}
      <span id="prompt-message" style={promptStyles.promptMessage}>
        {prompt}
      </span>
      <div id="digits" style={styles.digitContainer}>
        <Digits value={value} length={length} password={password} />
      </div>
      {children}
      {showForgotPin ? <ForgotPin onForgotPin={onForgotPin} /> : null}
    </div>
  );
};

Prompt.propTypes = {
  prompt: PropTypes.string,
  length: PropTypes.number,
  showForgotPin: PropTypes.bool,
  password: PropTypes.bool,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  onForgotPin: PropTypes.func,
  isPortrait: PropTypes.bool,
  isTablet: PropTypes.bool,
  children: PropTypes.node,
};

export default Prompt;



// WEBPACK FOOTER //
// ./src/components/PinEntry/Prompt.jsx